var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 139,
    viewBox: "0 0 139 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "verification 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x33_7_x2C__Accept_x2C__check_x2C__folder_x2C__plus"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_9506_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9558_",
    d: "M120.622 23.4688H21.9082C17.9587 23.4688 14.7256 26.7021 14.7256 30.6517V42.1643H127.796V30.6517C127.796 26.7021 124.568 23.4688 120.622 23.4688Z",
    fill: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9557_",
    d: "M14.7256 42.1641V106.934C14.7256 110.884 17.959 114.114 21.9082 114.114H120.622C124.568 114.114 127.796 110.884 127.796 106.934V42.1641H14.7256Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9556_",
    d: "M129.061 6.48438C131.141 6.48438 132.826 8.16948 132.826 10.2466C132.826 12.3267 131.141 14.0118 129.061 14.0118C126.981 14.0118 125.296 12.3267 125.296 10.2466C125.296 8.16948 126.981 6.48438 129.061 6.48438Z",
    fill: "#A4B0BF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9555_",
    d: "M35.896 126.148C37.9761 126.148 39.6612 127.834 39.6612 129.914C39.6612 131.991 37.9761 133.676 35.896 133.676C33.8186 133.676 32.1338 131.991 32.1338 129.914C32.1338 127.833 33.8186 126.148 35.896 126.148Z",
    fill: "#A4B0BF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9553_",
    d: "M43.7002 31.1797H48.3689V35.8514H43.7002V31.1797Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9552_",
    d: "M34.2383 31.1797H38.907V35.8514H34.2383V31.1797Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9551_",
    d: "M24.7754 31.1797H29.4441V35.8514H24.7754V31.1797Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9520_",
    d: "M120.622 115.602H21.908C17.128 115.602 13.2393 111.714 13.2393 106.936V30.6531C13.2393 25.8731 17.128 21.9844 21.908 21.9844H120.622C125.397 21.9844 129.281 25.8731 129.281 30.6531V106.936C129.281 111.714 125.397 115.602 120.622 115.602ZM21.908 24.9563C18.7667 24.9563 16.2112 27.5118 16.2112 30.6531V106.936C16.2112 110.076 18.7667 112.63 21.908 112.63H120.622C123.758 112.63 126.31 110.076 126.31 106.936V30.6531C126.31 27.5118 123.758 24.9563 120.622 24.9563H21.908Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9519_",
    d: "M127.795 43.6514H14.7251C13.9044 43.6514 13.2393 42.9859 13.2393 42.1655C13.2393 41.3448 13.9047 40.6797 14.7251 40.6797H127.795C128.616 40.6797 129.281 41.3451 129.281 42.1655C129.281 42.9862 128.616 43.6514 127.795 43.6514Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9516_",
    d: "M129.062 15.4994C126.166 15.4994 123.811 13.1437 123.811 10.2481C123.811 7.35431 126.166 5 129.062 5C131.957 5 134.313 7.35431 134.313 10.2481C134.313 13.1437 131.957 15.4994 129.062 15.4994ZM129.062 7.97167C127.805 7.97167 126.782 8.99272 126.782 10.2481C126.782 11.505 127.805 12.5274 129.062 12.5274C130.319 12.5274 131.341 11.5048 131.341 10.2481C131.341 8.99299 130.319 7.97167 129.062 7.97167Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9513_",
    d: "M35.8958 135.16C33.002 135.16 30.6475 132.805 30.6475 129.911C30.6475 127.016 33.0018 124.66 35.8958 124.66C38.7912 124.66 41.1468 127.016 41.1468 129.911C41.1468 132.805 38.7912 135.16 35.8958 135.16ZM35.8958 127.632C34.6407 127.632 33.6194 128.655 33.6194 129.911C33.6194 131.167 34.6407 132.188 35.8958 132.188C37.1525 132.188 38.1752 131.167 38.1752 129.911C38.1752 128.655 37.1525 127.632 35.8958 127.632Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9512_",
    d: "M12.8173 120.581H5.48583C4.66514 120.581 4 119.916 4 119.095C4 118.275 4.66541 117.609 5.48583 117.609H12.8173C13.638 117.609 14.3031 118.275 14.3031 119.095C14.3031 119.916 13.638 120.581 12.8173 120.581Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9511_",
    d: "M9.1499 124.245C8.3292 124.245 7.66406 123.579 7.66406 122.759V115.427C7.66406 114.607 8.32947 113.941 9.1499 113.941C9.97059 113.941 10.6357 114.607 10.6357 115.427V122.759C10.6357 123.579 9.97059 124.245 9.1499 124.245Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9510_",
    d: "M19.4086 15.4985C19.0283 15.4985 18.6482 15.3536 18.358 15.0633C17.7778 14.4832 17.7778 13.5422 18.358 12.9618L23.5406 7.77887C24.121 7.19871 25.0617 7.19871 25.6422 7.77887C26.2223 8.35903 26.2223 9.3 25.6422 9.88043L20.4595 15.0633C20.1693 15.3533 19.789 15.4985 19.4086 15.4985Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9509_",
    d: "M24.5913 15.4984C24.2109 15.4984 23.8308 15.3535 23.5406 15.0632L18.358 9.88033C17.7778 9.2999 17.7778 8.3592 18.358 7.77877C18.9387 7.19861 19.8791 7.19888 20.4595 7.77877L25.6422 12.9617C26.2223 13.5418 26.2223 14.4828 25.6422 15.0632C25.3517 15.3532 24.9716 15.4984 24.5913 15.4984Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9508_",
    d: "M131.688 131.397H124.357C123.536 131.397 122.871 130.732 122.871 129.912C122.871 129.091 123.536 128.426 124.357 128.426H131.689C132.509 128.426 133.174 129.091 133.174 129.912C133.174 130.732 132.509 131.397 131.688 131.397Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9507_",
    d: "M128.021 135.065C127.2 135.065 126.535 134.399 126.535 133.579V126.248C126.535 125.427 127.2 124.762 128.021 124.762C128.842 124.762 129.507 125.427 129.507 126.248V133.579C129.507 134.399 128.842 135.065 128.021 135.065Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.5 55C57.5383 55 47 65.5383 47 78.5C47 91.4617 57.5383 102 70.5 102C83.4617 102 94 91.4617 94 78.5C94 65.5383 83.4617 55 70.5 55Z",
    fill: "#00D37A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.5837 71.4153C81.1388 71.9603 81.1388 72.8569 80.5837 73.4019L67.1543 86.5869C66.8768 86.8594 66.5097 87 66.1427 87C65.7756 87 65.4085 86.8594 65.131 86.5869L58.4163 79.9944C57.8612 79.4494 57.8612 78.5528 58.4163 78.0078C58.9714 77.4628 59.8846 77.4628 60.4397 78.0078L66.1427 83.6071L78.5603 71.4153C79.1154 70.8616 80.0286 70.8616 80.5837 71.4153Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerification);
export default __webpack_public_path__ + "static/media/verification.76279c85a1f2029dfb3e366af6b5401b.svg";
export { ForwardRef as ReactComponent };